import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  searchPlaceHolder: () => __(translations.monitoringCalendarView.searchPlaceholder, 'Search...'),
};
